/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=399ce394&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=399ce394&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=399ce394&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399ce394"]])

export default __exports__